import React from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import SimpleBar from "simplebar-react";
import { truckRQ } from "Hooks/Queries";

export default function DetailTruck(props) {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, error, isFetching, status } = truckRQ.useGetData(id)();

  useEffect(() => {
    if (!isFetching && status === "success") {
    }
    if (!isFetching && status === "error") {
      console.log(error);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [status, isFetching]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Truck Detail" />
        <Row>
          <Col lg={12}>
            <form
              onSubmit={function (e) {
                e.preventDefault();
              }}
            >
              <Card>
                <CardHeader className="d-flex align-items-center">
                  <h6 className="card-title mb-0 flex-grow-1">Detail Truck</h6>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive table-card">
                    <SimpleBar style={{ maxHeight: "365px" }}>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex items-center">
                            <div className="ms-3 col-6">Truck Category :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.truck_category?.name ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Type :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.truck_type?.name ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Merk :</div>
                            <div className="ms-3 col-3">
                              <h6>
                                {data?.data?.brand}
                              </h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Plat Number :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.plate_number ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Capacity :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.capacity ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Dimensi :</div>
                            <div className="ms-3 col-3">
                              <h6>
                                {data?.data?.length ?? "-"}{'\u00A0'}x{'\u00A0'}
                                {data?.data?.width ?? "-"}{'\u00A0'}x{'\u00A0'}
                                {data?.data?.height ?? "-"}
                              </h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">STNK Expired :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.stnk_expired ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">KIR Expired :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.kir_expired ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">STNK Photo :</div>
                            <div className="ms-3 col-3">
                              <a
                                className="text-decoration-underline"
                                target={data?.data?.stnk_url ? "_blank" : ""}
                                rel="noreferrer"
                                href={data?.data?.stnk_url ? data?.data?.stnk_url : "#"}
                              >
                                Preview
                              </a>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">KIR Photo :</div>
                            <div className="ms-3 col-3">
                              <a
                                className="text-decoration-underline"
                                target={data?.data?.kir_url ? "_blank" : ""}
                                rel="noreferrer"
                                href={data?.data?.kir_url ? data?.data?.kir_url : "#"}
                              >
                                Preview
                              </a>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Truck Photo :</div>
                            <div className="ms-3 col-3">
                              <a
                                className="text-decoration-underline"
                                target={data?.data?.truck_url ? "_blank" : ""}
                                rel="noreferrer"
                                href={data?.data?.truck_url ? data?.data?.truck_url : "#"}
                              >
                                Preview
                              </a>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Waktu Dibuat :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.created_on ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item list-group-item-action">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 col-6">Waktu Diubah :</div>
                            <div className="ms-3 col-3">
                              <h6>{data?.data?.updated_on ?? "-"}</h6>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </SimpleBar>
                  </div>
                </CardBody>
                <CardFooter className="text-end">
                  <Link className="btn btn-light" to="/app/truck/data">
                    Kembali
                  </Link>
                </CardFooter>
              </Card>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
